<template>
  <div class="mini-upload-list-container" v-show="visible">
    <div class="header">
      <div class="title">上传列表</div>
      <div class="close-btn">
        <span class="icon" @click="closeDialog">
          <i class="el-icon-close"></i>
        </span>
      </div>
    </div>
    <div class="common-table-box">
      <el-table highlight-selection-row class="publish-table" height="100%" size="mini" v-loading="tableLoading" :data="fileUploadList">
        <el-table-column label="序号" type="index" width="75" />
        <el-table-column label="文件名称" width="240">
          <template v-slot="{ row }">
            <span class="text-overflow" :title="row.fileName">{{
              row.fileName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" width="100">
          <template v-slot="{ row }">
            <span>{{
              `${formatFileSize(row.length).fileSize}${formatFileSize(row.length).unit
              }`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传进度" width="270">
          <template v-slot="{ row }">
            <div v-if="row.status === -1 || row.status === -2">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>等待上传</span>
            </div>
            <div v-else-if="row.status === -3">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>等待更新</span>
            </div>
            <div v-else-if="row.status === 5">
              <span class="error-text">
                <i class="el-icon-error icon"></i>校验失败</span>
            </div>
            <div v-else-if="row.status === 7">
              <span class="error-text"><i class="el-icon-error icon"></i>上传失败</span>
            </div>
            <ProgressBar v-else :fileInfo="row" :uploadControl="uploadControl" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="50">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button title="删除" class="button-icon" icon="el-icon-close" circle :disabled="row.status === 1"
                @click="deleteFileById(row)"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar.vue";
import { Store } from "@/utils/store";
import { formatFileSize, getToken } from "@/utils/generalMethods";

import {
  publicElemFileListService,
  privateElemFileListService,
  deleteFileService,
} from "@/service/interface";
export default {
  data() {
    return {
      visible: false,
      fileUploadList: [],
      tableLoading: false,
    };
  },
  props: {
    elemUploader: Object,
    type: String,
  },
  components: {
    ProgressBar,
  },
  mounted() {
    this.elemUploader.on("startUploadFile", this.onStartUploadFile);
  },
  beforeDestroy() {
    this.clearTimer();

    this.elemUploader.off("startUploadFile", this.onStartUploadFile);
  },
  methods: {
    onStartUploadFile() {
      this.visible = true;

      this.tableLoading = true;
      this.queryFilesUpload().then(() => {
        this.tableLoading = false;
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000);
        }
      });
    },
    deleteFileById(fileInfo) {
      if (fileInfo.status < 0) {
        let find = Store.uploaders.find(
          (el) => el.schemeType === fileInfo.schemeType
        );
        if (find) {
          let uploader = find.uploader;
          let findIndex = uploader.uploadFiles.findIndex((el) =>
            this.isSameFile(el, fileInfo)
          );
          if (findIndex !== -1) {
            uploader.uploadFiles.splice(findIndex, 1);
          }
        }
        return;
      }

      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.refreshFileList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    uploadControl(fileInfo) {
      let find = Store.uploaders.find(
        (el) => el.schemeType === fileInfo.schemeType
      );

      let uploader = find.uploader;
      let fileStatus = fileInfo.status;
      if (fileStatus === 1) {
        uploader.fire("pauseFileUpload", { fileInfo });
      }
      if (fileStatus === 2) {
        uploader.setStatus("continue");
        uploader.setCurrFileInfo(fileInfo);

        let pausedFiles = uploader.pausedFiles;
        let findPauseFile = pausedFiles.find(
          (el) => el.fileDataId === fileInfo.fileDataId
        );
        if (findPauseFile) {
          uploader.fire("continueFileUpload", { fileInfo });
        }
      }
    },
    refreshFileList() {
      this.queryFilesUpload().then(() => {
        let uploadingList = this.fileUploadList.filter(
          (el) =>
            el.status === -1 ||
            el.status === -2 ||
            el.status === 0 ||
            el.status === 1 ||
            el.status === 6
        );
        if (!uploadingList.length) {
          this.clearTimer();
        }

        let pauseList = this.fileUploadList.filter((el) => el.status === 2);
        if (pauseList.length) {
          this.refreshDom();
        }
      });
    },
    queryFilesUpload() {
      return new Promise((resolve) => {
        this.queryElemUploadList().then((fileUploadList) => {
          fileUploadList.forEach((item) => {
            item["fileType"] = item.suffix;
            item["schemeType"] = item.scheme;
            item["status"] = item.uploadStatus;
            item["length"] = item.size;
            item["fileDataId"] = item.id;
            if (item.blobIndex || item.blobIndex === 0) {
              let currIndex = item["blobIndex"] + 1;
              let rate = Math.floor((currIndex / item.blobCount) * 10000);
              item["rate"] = rate;
            }
          });

          let customUploadList = [];
          let uploadFiles = this.elemUploader.uploadFiles;
          customUploadList = [...uploadFiles];

          let tempFileList = [];
          customUploadList.forEach((item) => {
            let findIndex = fileUploadList.findIndex((el) =>
              this.isSameFile(item, el)
            );
            if (findIndex === -1) {
              tempFileList.push(item);
            } else {
              let status = fileUploadList[findIndex].status;
              // 如果后端接口返回的状态不是上传中，则按前端状态显示
              if (status !== 0 && status !== 1 && status !== 6) {
                fileUploadList[findIndex].status = item.status;
              }
            }
          });
          fileUploadList = [...fileUploadList, ...tempFileList];
          this.fileUploadList = fileUploadList;
          resolve();
        });
      });
    },
    queryElemUploadList() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status: [0, 1, 2, 5, 6, 7],
        };
        if (this.type === "PublicElem") {
          publicElemFileListService(params).then((response) => {
            if (response.isSuccess) {
              let result = response.data;
              let fileUploadList = result.items;

              resolve(fileUploadList);
            }
          });
        } else {
          privateElemFileListService(params).then((response) => {
            if (response.isSuccess) {
              let result = response.data;
              let fileUploadList = result.items;

              resolve(fileUploadList);
            }
          });
        }
      });
    },
    isSameFile(fileInfo1, fileInfo2) {
      return (
        fileInfo1.fileName === fileInfo2.fileName &&
        fileInfo1.length === fileInfo2.length &&
        fileInfo1.fileDataId === fileInfo2.fileDataId
      );
    },
    closeDialog() {
      this.clearTimer();
      this.visible = false;
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    refreshDom() {
      this.fileUploadList.forEach((item) => {
        let find = Store.uploaders.find(
          (el) => el.schemeType === item.schemeType
        );
        if (find) {
          let pausedFiles = find.uploader.pausedFiles;
          let findPauseFile = pausedFiles.find(
            (el) => el.fileDataId === item.id
          );
          if (item.status === 2 && !findPauseFile) {
            let continueDom = document.getElementById(`continue-${item.id}`);
            if (continueDom) {
              if (
                !continueDom.children[0] ||
                !continueDom.children[0].className.includes("webuploader-pick")
              ) {
                let uploader = find.uploader;
                uploader.uploader.addButton({
                  id: `#continue-${item.id}`,
                  multiple: false,
                });
              }
            }
          }
        }
      });
    },
    formatFileSize,
    getToken,
  },
};
</script>

<style lang="less" scoped>
.mini-upload-list-container {
  position: absolute;
  height: 300px;
  background: var(--mini-upload-dialog-bgColor);
  border: 1px solid var(--mini-upload-dialog-border-color);
  bottom: 16px;
  right: 16px;
  z-index: 2;
  border-radius: 8px 8px 0px 0px;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: var(--mini-upload-dialog-header-bgColor);
    border-radius: 8px 8px 0px 0px;

    .title{
      color: var(--mini-upload-dialog-title-color);
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;

      .icon {
        display: flex;
        color: var(--default-color);
        cursor: pointer;

        &:hover {
          background: var(--base-bg-dark-color4);
        }
      }
    }
  }

  .common-table-box {
    height: calc(100% - 41px);
    padding: 8px 16px;

    .error-text {
      font-size: 13px;
      color: var(--error-status-color);

      .icon {
        margin-right: 5px;
      }
    }

    .wating-text {
      font-size: 15px;
      color: var(--runing-status-color);

      .icon {
        margin-right: 10px;
      }
    }

    .button-icon {
      font-size: 18px;
      color: var(--icon-color);
      border: none;
      background: transparent;
      padding: 0px;

      &:hover {
        color: var(--primary-color);
      }
    }
  }
}
</style>